import {
  WSAlert,
  WSCard,
  WSMenuItem,
  WSPillProps
} from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { ListItemProps } from "./types";

const pillDefault: WSPillProps = {
  text: "Current default",
  icon: "check",
  theme: "blue",
  type: "dark"
};

const pillInitialDefault: WSPillProps = {
  text: "Current default"
};

const pillNewDefault: WSPillProps = {
  text: "Set as default",
  icon: "check",
  theme: "blue",
  type: "dark"
};

type Props = {
  initialActive?: boolean;
  active?: boolean;
} & ListItemProps;

export const Item: React.FC<Props> = props => {
  const menu = useMemo(() => {
    const menu: WSMenuItem[] = [];

    if (!!props.actions.select) {
      menu.push({
        label: "Set as default",
        icon: "checkbox",
        onClick: props.actions.select
      });
    }

    if (!!props.actions.reconnect) {
      menu.push({
        label: "Reconnect with Plaid",
        icon: "refresh-v",
        onClick: props.actions.reconnect
      });
    }

    if (!!props.actions.resync) {
      menu.push({
        label: "Reconnect with Plaid",
        icon: "refresh-v",
        onClick: props.actions.resync
      });
    }

    if (!!props.actions.remove) {
      menu.push(
        {
          separator: true
        },
        {
          label: "Remove",
          icon: "trash",
          iconProps: {
            color: "red400"
          },
          labelProps: {
            color: "red400"
          },
          onClick: props.actions.remove
        }
      );
    }
    return menu;
  }, [
    props.actions.reconnect,
    props.actions.remove,
    props.actions.resync,
    props.actions.select
  ]);

  const pill = useMemo(
    () =>
      props.pill
        ? props.pill
        : props.active && props.initialActive
        ? pillDefault
        : props.initialActive
        ? pillInitialDefault
        : props.active
        ? pillNewDefault
        : undefined,
    [props.active, props.initialActive, props.pill]
  );

  return (
    <WSCard
      active={props.active}
      onClick={props.actions.select}
      header={{
        label: props.label,
        value: {
          pill,
          menu: menu,
          action: props.actions.verify
            ? {
                label: "Verify",
                onClick: props.actions.verify
              }
            : props.actions.reconnect
            ? {
                label: "Reconnect",
                onClick: props.actions.reconnect
              }
            : undefined
        }
      }}
    >
      {!!props.actions.resync && (
        <WSAlert
          theme="warning"
          icon="alert"
          action={{
            text: "Reconnect with Plaid",
            onClick: props.actions.resync
          }}
          title="Action required"
        >
          The missing information (such as account and routing number) must be
          provided in order for the account to receive payouts through Wingspan.
          Reconnect the account with Plaid and ensure to{" "}
          <b>share account and routing numbers</b> after you’ve signed in to
          your bank account. If you continue to experience issues with
          connecting with Plaid, try adding the account by entering the details
          manually.
        </WSAlert>
      )}
    </WSCard>
  );
};
